import { useContext } from 'react';

// TODO remove export from /app after refactoring all modals
import { ModalContext } from '@/app/providers/ModalProvider';

export const useModalContext = () => useContext(ModalContext);
